<template lang="html">
<div class="v-scope-home-modulo-guias">
<div>

        <h2>{{$t('guias.titulo')}}</h2>

        <section class="listado-eventos container row-between">


            <div class="container">
  
                <template v-if="guiasOrientacion.length != 0">
                  <guia-orientacion :key="key" :data="guia" v-for="(guia,key) in guiasOrientacion.slice(0,4)"></guia-orientacion>
                </template>
          
                <p v-else>{{$t('guias.zero')}}</p>
          
              </div>
          


        </section>


    </div>
</div>
</template>

<script lang="js">

    import { mapGetters,mapActions } from 'vuex';

    import guiaorientacion from '@/components/parts/guia-orientacion'


    export default {
        name: 'modulo-guias',
        mounted() {
            this.requestGuiasOrientacion();
        },
        components: {
            'guia-orientacion': guiaorientacion
        },
        methods: {
            ...mapActions([
                'requestGuiasOrientacion'
            ])
        },
        computed: {
            ...mapGetters({
                guiasOrientacion: 'getGuiasOrientacion'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/home/modulo-guias.vue